<div class="banner wrapper">
    <div id="prod-title" class="prod-title">
        <div class="row">
            <div class="col-xs-12 center-xs">
                <h5
                    class="text-align-center pt-25"
                    [innerHTML]="'label.gb.title.merlin.pcn' | translate"
                ></h5>
                <hr class="hrLogin" />
            </div>
        </div>
    </div>
</div>
<!-- <div class="spinnerWrapper">
    <mat-spinner color="primary" class="spinner" [diameter]="75" role="img" [attr.aria-label]="translate('label.gb.loading')"></mat-spinner>
    <div style="position:relative; top: 0px; left: -65px;">{{translate('label.gb.loading')}}</div>
</div> -->